import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	// const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);










  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/payslipdisplay/${param}`)
    //   .then(res => console.log(res.data))
      .then(res => setData(res.data))
      .catch(err => console.log(err));
  }, [param]);

  if (!data) return <h3>Loading...</h3>;

  // leave / holiday summary cards -- same order the CI payslip listed them in,
  // and only the ones with a value are shown
  const summaryCards = [
    { label: "SL", value: data.salary.sl_leaves },
    { label: "CL", value: data.salary.cl_leaves },
    { label: "COMBO OFF", value: data.salary.co_leaves },
    { label: "WEEK OFF", value: data.salary.wo_leaves },
    { label: "Special Leaves", value: data.salary.spl_leaves },
    { label: "Holidays", value: data.salary.holidays },
    { label: "Paternity", value: data.salary.pl_leaves },
    { label: "Maternity", value: data.salary.mat_leaves },
  ].filter((c) => Number(c.value) > 0);

  // earnings sit beside deductions, so the two lists are walked together
  const payRows = data.earnings.map((earning, i) => ({
    earning,
    deduction: data.deductions[i],
  }));

  const cell = { border: "1px solid #b6b6b6", padding: "7px 10px", fontWeight: 600 };
  const amountCell = { ...cell, textAlign: "right" };

  return (
    <>
      <div>
        <div>
          <div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
            <div className="container-fluid">
              <ToastContainer />
            </div>
          </div>

          <div className="section-body mt-3">
            <div className="container-fluid">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Payslip - {data.salary.payment_month}</h3>
                </div>

                <div className="card-body">

                  {summaryCards.length > 0 && (
                    <div className="row">
                      {summaryCards.map((card) => (
                        <div className="col-lg-3 col-md-4 col-sm-6" key={card.label}>
                          <div className="card">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <i className="fa fa-calendar" style={{ fontSize: "26px", color: "#fa626b" }} />
                                <div className="ml-3" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                                  {card.label} ({card.value})
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Employee details */}
                  <div className="table-responsive">
                    <table width="100%" style={{ borderCollapse: "collapse", marginBottom: "20px" }}>
                      <tbody>
                        <tr>
                          <td style={cell}>Name</td>
                          <td style={cell}>{data.employee.name}</td>
                          <td style={cell}>Employee Id</td>
                          <td style={cell}>{data.employee.employee_id}</td>
                        </tr>
                        <tr>
                          <td style={cell}>Department</td>
                          <td style={cell}>{data.employee.department}</td>
                          <td style={cell}>Designation</td>
                          <td style={cell}>{data.employee.designation}</td>
                        </tr>
                        <tr>
                          <td style={cell}>Date Of Joining</td>
                          <td style={cell}>{data.employee.date_of_joining}</td>
                          <td style={cell}>PF UAN</td>
                          <td style={cell}>{data.salary.uan_no}</td>
                        </tr>
                        <tr>
                          <td style={cell}>Total Days</td>
                          <td style={cell}>{data.salary.total_days}</td>
                          <td style={cell}>Days Worked</td>
                          <td style={cell}>{data.salary.days_worked}</td>
                        </tr>
                        <tr>
                          <td style={cell}>ESIC NO</td>
                          <td style={cell}>{data.salary.esi_no}</td>
                          <td style={cell}>Bank Account Number</td>
                          <td style={cell}>{data.salary.account_no}</td>
                        </tr>
                        <tr>
                          <td style={cell}>LOP Days</td>
                          <td style={cell}>{data.salary.lop_days}</td>
                          <td style={cell} colSpan="2" />
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Earnings & deductions */}
                  <div className="table-responsive">
                    <table width="100%" style={{ borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#c4e5fd" }}>
                          <th style={cell}>Earnings</th>
                          <th style={cell}>Amount</th>
                          <th style={cell}>Deduction</th>
                          <th style={cell}>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {payRows.map((row, i) => (
                          <tr key={i}>
                            <td style={cell}>{row.earning.label}</td>
                            <td style={amountCell}>{row.earning.amount}</td>
                            <td style={cell}>{row.deduction ? row.deduction.label : ""}</td>
                            <td style={amountCell}>{row.deduction ? row.deduction.amount : ""}</td>
                          </tr>
                        ))}
                        <tr>
                          <td style={cell}>Net Take Home</td>
                          <td style={cell} colSpan="3">{data.salary.net_take_home}</td>
                        </tr>
                        <tr>
                          <td style={cell} colSpan="4">{data.salary.net_take_home_words}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);